import { writable } from "svelte/store";
import type { WalletTransaction, ApiResultOfListOfWalletTransaction } from "./walletapi";
import { service } from "./services";
import { RegisterStartupCallback } from "./startup";

export const Transactions = writable<WalletTransaction[]>([]);

export async function TransactionListStartup(firstStartup: boolean) {
    await RefreshTransactions();

    if (!firstStartup) {
        return;
    }
    service.walletapi.registerOperation("TransactionChanged", "TransactionChanged", TransactionChanged);
    service.walletapi.registerOperation("TransactionAdded", "TransactionAdded", TransactionAdded);
}

export async function RefreshTransactions() {
    try {
        let response: ApiResultOfListOfWalletTransaction = await service.walletapi.transactionList({
            Token: sessionStorage.token,
        });

        if (response.Success && response.Data) {
            // Crear una nueva lista para forzar la reactividad
            Transactions.set([...response.Data]);
        }
    } catch (error) {
        // Error handling without console.log
    }
}

export function TransactionChanged(transaction: WalletTransaction) {
    Transactions.update(list => {
        let transactionIndex = list.findIndex(t => t.Id == transaction.Id);
        if (transactionIndex == -1) {
            // Si la transacción no está en la lista, la agregamos al inicio
            return [transaction, ...list];
        }

        // Crear una nueva lista con la transacción actualizada
        const newList = [...list];
        newList[transactionIndex] = transaction;
        return newList;
    });
}

export function TransactionAdded(transaction: WalletTransaction) {

    Transactions.update(list => {
        // Agregar la nueva transacción al inicio de la lista
        const newList = [transaction, ...list];
        // Mantener solo las últimas 100 transacciones
        while (newList.length > 100) {
            newList.pop();
        }
        return newList;
    });
}

RegisterStartupCallback("TransactionListStartup", TransactionListStartup);